import React from 'react';
import PageHeader from './PageHeader/PageHeader';
import { adminMenu } from './helpers/navigationData';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AdminLayout = ({ children, title, back }) => {

  return (
    <>
      <PageHeader 
        navItems={adminMenu} 
        title={title} 
        backLink={back} 
      />
      {children}
      <ToastContainer position="top-right" />
    </>
  );
};

export default AdminLayout;
export { AdminLayout };
